angular.module('app.purchase.billingInfo.billingInfoService', [
  'app.shared.selectWithDisabledOption.selectWithDisabledOptionDirective',
])
  .factory('app.purchase.billingInfo.billingInfoService', [
    '$http', '$q',
    function ($http, $q) {
      "use strict";

      /**
       * @typedef {{expiry: Date, currency_code: string, country_code: string}} BillingData
       */

      /**
       * @type {{data: BillingData, error: null, retrieve: retrieve, release: release, validate: validate, save: save, calcDate: calcDate, getPlan: ((p1:*, p2:*))}}
       */
      let billing = {
        data: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('my_account/billing_info'))
            .then((response) => {
              let data = response.data;
              if (data.billing_info) {
                billing.data = data.billing_info;
              }
              if (data.error) {
                return billing.error = data.error;
              } else {
                return billing.error = null;
              }
            });
        },
        release: function () {
          return billing.data = null;
        },
        validate: function (form) {
          let deferred = $q.defer();

          recurly.token(form, function (err, token) {
            if (err) {
              deferred.reject(err);
            } else {
              deferred.resolve(token);
            }
          });

          return deferred.promise;
        },
        save: function (token) {
          return $http.put(window.location.api('my_account/billing_info'), {
            token_id: token.id
          })
        },
        calcDate: function () {
          if (billing.data) {
            let date = moment(billing.data.expiry);
            if (date.isValid()) {
              billing.data.expiry_month = date.month();
              billing.data.expiry_year = date.year();
            }
          }
        },
        getPlan: (plan_code, args) => {
          let query = '';
          if (args.currency_code) {
            query += 'currency=' + args.currency_code;
          }
          else if (args.country_code) {
            query += 'country=' + args.country_code;
          }

          return $http.get(window.location.api('subscriptions/plans/' + plan_code + '?' + query));
        }
      };

      return billing;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/billingInfo/billingInfoService.js